<template>
  <div>
    <a-form
      ref="addForm" :form="form" :disabled="$route.query.titless == '查看'"
      class="detail-form"
    >
      <div class="card-container">
        <div class="card-title subtitle">
          基础信息
        </div>
        <div class="card-content">
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="昵称"
                v-bind="formItemLayout"
              >
                <a-input
                  v-decorator="[
                    'userName',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请填写昵称',
                        }
                      ]
                    }
                  ]"
                  :disabled="$route.query.titless == '查看'"
                  placeholder="请填写昵称"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="真实姓名"
                v-bind="formItemLayout"
              >
                <a-input
                  v-decorator="[
                    'realName',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请填写真实姓名',
                        }
                      ]
                    }
                  ]"
                  :disabled="$route.query.titless == '查看'"
                  placeholder="请填写真实姓名"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="手机号"
                v-bind="formItemLayout"
              >
                <a-input
                  v-decorator="[
                    'mobile',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请填写手机号',
                        }
                      ]
                    }
                  ]"
                  :disabled="$route.query.titless == '查看'"
                  placeholder="请填写手机号"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="密码"
                v-bind="formItemLayout"
              >
                <a-input-password
                  v-decorator="[
                    'password',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请填写密码',
                        }
                      ]
                    }
                  ]"
                  :disabled="$route.query.titless == '查看'"
                  placeholder="请填写密码"
                />
              </a-form-item>
              <!-- <a-form-item label="区域" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                <a-cascader
                  v-decorator="['area', { rules: [{ required: true, message: '请选择省市区' }] }]"
                  :disabled="$route.query.titless == '查看'"
                  :options="options"
                  :load-data="loadData"
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区"
                  change-on-select
                  @change="changeArea"
                />
              </a-form-item> -->
            </a-col>
          </a-row>
        </div>

        <div class="card-content mb40 mt40">
          <a-row type="flex" justify="center">
            <a-col
              :span="12" type="flex" align="middle"
              style="text-align:center;"
            >
              <a-button
                v-if="$route.query.titless != '查看'"
                type="primary"
                @click="save"
              >
                保存
              </a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { addPostHouseUserInfo } from '@/api/postManagement'
import md5 from 'md5'
export default {
  data () {
    return {
      form: this.$form.createForm(this, { name: 'addForm' }),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 17 }
      }
    }
  },
  methods: {
    save () {
      this.form.validateFields((err, values) => {
        if (!err) {
          var params = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
          params.password = md5(params.password)
          addPostHouseUserInfo(params).then((res) => {
            this.$message.success(res.msg)
            this.$router.push({
              path: '/takeBack/recyclerList'
            })
          })
        }
      })
    }
  }
}
</script>

<style>

</style>
